import { useT } from "@/i18n"

/**
 * Top of the funnel. Mirrors PromptJuggler's hero proportions (centred,
 * max-w-3xl, generous top space) but in Figtree and the neutral palette:
 * quiet sub-line, heavy headline, a bulleted promise, then "One profile."
 */
export default function Hero() {
  const { t } = useT("content")

  return (
    <section className="mx-auto max-w-3xl px-6 pt-24 pb-16 text-center sm:pt-28 sm:pb-24">
      <p className="text-xl text-foreground/80 sm:text-2xl">
        {t("home.hero.sub")}
      </p>

      <h1 className="mt-8 mb-10 text-4xl leading-[1.1] font-normal tracking-tight text-balance sm:mt-10 sm:mb-12 sm:text-5xl">
        {t("home.hero.title")}
      </h1>

      <p className="text-lg text-muted-foreground sm:text-xl">
        {t("home.hero.bullets")}
      </p>
      <p className="mt-2 text-lg font-medium text-foreground/80 sm:text-xl">
        {t("home.hero.one")}
      </p>
    </section>
  )
}
